import { ProjectWizardContext } from 'context/Context';
import { useContext } from 'react';
import Emprendimiento from './steps/Emprendimiento';
import Ubicacion from './steps/Ubicacion';
import Unidades from './steps/Unidades';
import Multimedia from './steps/Multimedia';
import Extras from './steps/Extras';

const Steps = () => {
  const { step } = useContext(ProjectWizardContext);

  switch (step) {
    case 1:
      return <Emprendimiento />;

    case 2:
      return <Ubicacion />;

    case 3:
      return <Unidades />;

    case 4:
      return <Multimedia />;

    case 5:
      return <Extras />;
  }
};

export default Steps;
